// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Backdrop/Backdrop.scss
// module id = 150
// module chunks = 0